import React, { Component } from "react";
import "./index.css";
import { connect } from "react-redux";
import defaultImage from "../../../Assets/img/default-avatar.png";
import axios from "axios";
import store from "store";
import MySnackbar from "../../MyComponents/MySnackbar";

const mapStateToProps = ({ dispatch, user }) => ({
  dispatch,
  user,
});
class TopImgProfile extends Component {
  state = {
    sessionList: [],
    currentSession: store.get("session"),
    snackbar: false,
  };
  componentDidMount = () => {
    axios.get(`/api/cachedsession`).then((res) => {
      this.setState({ sessionList: res?.data });
    });
  };
  handleSession = (e) => {
    // console.log(e.target.value);
    let sessionObj = JSON.parse(e.target.value);

    // console.log(sessionObj, "asdfg");

    axios
      .get(
        `api/session_student?session=${sessionObj.id}&user=${this.props.user.id}`
      )
      .then((response) => {
        if (response.data.results.length > 0) {
          store.set("session", sessionObj);
          this.props.dispatch({
            type: "user/LOAD_CURRENT_ACCOUNT",
          });
        } else {
          this.setState({ snackbar: true });
        }
      })
      .catch((err) => {
        console.log(err, "errorrr");
        this.setState({ snackbar: true });

        // setTimeout(function () {
        //   window.location.reload(1);
        // }, 1500);
      });
  };
  render() {
    if (this.props.user.role.id === 9) {
      return (
        <React.Fragment>
          <div className="pb-2">
            <div className="th-bg-primary" style={{ height: 100 }}></div>
            <div
              className="th-bg-primary"
              style={{
                height: 40,
                position: "absolute",
                zIndex: -1,
                width: "100%",
              }}
            ></div>
            <div className="d-flex">
              <div className="th-profile-img-wrap shadow-sm mx-auto">
                <div
                  className="th-profile-img"
                  style={{
                    backgroundImage: `url('${
                      this.props.user?.studentData?.student_photo
                        ? this.props.user?.studentData?.student_photo
                        : defaultImage
                    }')`,
                  }}
                ></div>
              </div>
            </div>
            <div className="d-flex mt-2">
              <div className="mx-auto">
                <div className="th-14 th-grey text-center th-medium">
                  {this.props.user.user.first_name}{" "}
                  {this.props.user.user.last_name}
                </div>
                <div className="th-12 th-grey text-center">
                  Student: {this.props.user.student_class.class_name}{" "}
                  {this.props.user.student_section.section_name}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 text-center">
            <div className="th-14">Current Session</div>
            <select
              className="th-select"
              name="session"
              id="session"
              onChange={(e) => this.handleSession(e)}
            >
              {this.state.sessionList?.map((eachSession, i) => {
                return (
                  <option
                    key={i}
                    value={JSON.stringify(eachSession)}
                    selected={
                      this.state.currentSession?.id === eachSession.id
                        ? "selected"
                        : ""
                    }
                  >
                    {" "}
                    {eachSession.session}
                  </option>
                );
              })}
            </select>
          </div>
          {this.state.snackbar ? (
            <MySnackbar title="You are not in the selected session" />
          ) : null}
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <div className="pb-2">
            <div className="th-bg-primary" style={{ height: 100 }}></div>
            <div
              className="th-bg-primary"
              style={{
                height: 40,
                position: "absolute",
                zIndex: -1,
                width: "100%",
              }}
            ></div>
            <div className="d-flex">
              <div className="th-profile-img-wrap shadow-sm mx-auto">
                <div
                  className="th-profile-img"
                  style={{
                    backgroundImage: `url('${
                      this.props.user?.staffData?.staff_image
                        ? this.props.user?.staffData?.staff_image
                        : defaultImage
                    }')`,
                  }}
                ></div>
              </div>
            </div>
            <div className="d-flex mt-2">
              <div className="mx-auto">
                <div className="th-14 th-grey text-center th-medium">
                  {this.props.user?.user?.first_name}{" "}
                  {this.props.user?.user?.last_name}
                </div>
                <div className="th-12 th-grey text-center">
                  {this.props.user?.staffData?.designation?.designation}
                </div>
              </div>
            </div>
          </div>
          <div className="col-12 text-center">
            <div className="th-14">Current Session</div>
            <select
              className="th-select"
              name="session"
              id="session"
              onChange={(e) => this.handleSession(e)}
            >
              {this.state.sessionList?.map((eachSession, i) => {
                return (
                  <option
                    key={i}
                    value={JSON.stringify(eachSession)}
                    selected={
                      this.state.currentSession?.id === eachSession.id
                        ? "selected"
                        : ""
                    }
                  >
                    {" "}
                    {eachSession.session}
                  </option>
                );
              })}
            </select>
          </div>
          {this.state.snackbar ? (
            <MySnackbar title="You are not in the selected session" />
          ) : null}
        </React.Fragment>
      );
    }
  }
}
export default connect(mapStateToProps)(TopImgProfile);
